import KenAll from 'ken-all';

export function setAdrresEvent () {
  let target = document.getElementById('get_address');

  if (!!target) {
    target.addEventListener('click', function(event) {
      //正規表現
      const regex = new RegExp(/^[0-9]{3,}[-][0-9]{4,}$|^[0-9]{7,}$/);
      // 確認メッセージ
      const message = '郵便番号を元に住所を更新します。\nよろしいですか？';
      // 対象を取得
      var postcode = document.querySelector('input[name$="[zip_code]"]');
      var address = document.querySelector('input[name$="[address]"]');

      if (!!postcode && !!address) {
        if (regex.test(postcode.value)) {
          if (window.confirm(message)) {
            var pCode = postcode.value.replace('-', '')
            KenAll(pCode).then(response => {
              if (response.length === 0) {
                alert('入力された郵便番号に該当する住所はありません。');
              } else {
                address.value = response[0].join('');
              }
            });
          }
        } else {
          alert('郵便番号を正しく入力してください。');
        }
      }
    });
  }
}
